// extracted by mini-css-extract-plugin
export default {"Progress":"progress_Progress__BMmQq","Bar":"progress_Bar__RO43x"};